import { SideMenu } from "../models/SideMenu";
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import { HomeRounded, PeopleAltRounded, KeyRounded } from "@mui/icons-material";

export const ClientMobileMenu: SideMenu[] = [{
    label: "Management Contacts",
    icon: HomeRounded,
    link: "",
    policy: 'management-contacts'
},
{
    label: "Emergency Contacts",
    icon: HomeRounded,
    link: "",
    policy: 'emergency-contacts'
},
{
    label: "Employee Database",
    icon: HomeRounded,
    link: "",
    policy: 'employee-database'
},
{
    label: "Legislation",
    icon: HomeRounded,
    link: "",
    policy: 'legislation'
},
{
    label: "Government Authorities",
    icon: HomeRounded,
    link: "",
    policy: 'government-authorities'
},
{
    label: "Company Documents",
    icon: HomeRounded,
    link: "",
    policy: 'company-documents'
},
{
    label: "Site Induction",
    icon: HomeRounded,
    link: "",
    policy: 'site-induction'
},
{
    label: "Equipment",
    icon: HomeRounded,
    link: "",
    policy: 'equipment'
},
{
    label: "Vehicle",
    icon: HomeRounded,
    link: "",
    policy: 'vehicle'
},
{
    label: "Chemical",
    icon: HomeRounded,
    link: "",
    policy: 'chemical'
},
{
    label: "Digital Safety Files",
    icon: HomeRounded,
    link: "",
    policy: 'digital-safety-files'
},
{
    label: "Attendance",
    icon: HomeRounded,
    link: "",
    policy: 'attendance'
},
{
    label: "DSTI",
    icon: HomeRounded,
    link: "",
    policy: 'dsti'
},
{
    label: "Toolbox Talk",
    icon: HomeRounded,
    link: "",
    policy: 'toolbox-talk'
},
{
    label: "Incident",
    icon: HomeRounded,
    link: "",
    policy: 'incident'
},
{
    label: "PTO",
    icon: HomeRounded,
    link: "",
    policy: 'pto'
},
{
    label: "PPE",
    icon: HomeRounded,
    link: "",
    policy: 'ppe'
},
{
    label: "DTP",
    icon: HomeRounded,
    link: "",
    policy: 'dtp'
},
{
    label: "Organogram",
    icon: HomeRounded,
    link: "",
    policy: 'organogram'
},
{
    label: "Checklists Permits & Audits",
    icon: HomeRounded,
    link: "",
    policy: 'checklist'
},
{
    label: "Policies & Procedures",
    icon: HomeRounded,
    link: "",
    policy: 'policies-procedures'
},
{
    label: "Risk Assessments",
    icon: HomeRounded,
    link: "",
    policy: 'risk-assessments'
},
{
    label: "Site Documents",
    icon: HomeRounded,
    link: "",
    policy: 'site-documents'
}
];

// Legal Reference